module.exports = __webpack_public_path__ + "img/a-propos.a90bbfdb.jpg";